import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnExpander, ColumnNameH2H, ColumnBib } from "components/common/TableColumns"
import StatsBox from "components/sports/vvo/views/StatsBox"
import { dateFormat } from "helpers/utils"

import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { capitalizeFirstLetter } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TableColumns = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: 'HeaderShirtNo', headerClassName: 'text-end w-10' }),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: true, hideNoc: true }),
      ColumnPosition({}),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}

export function ColumnPosition({
  disableSort = true,
  className = 'text-start',
  headerClassName = 'text-start w-10',
  label = 'HeaderPosition',
  code = 'Position'
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'functionDescription',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: code
    }
  )
}


const getConfigurationFirstBox = (date) => {

  const formatedDate = date ? dateFormat(date, "", "D MMM H:mm") : "";

  let configuration = {
    header: `Current Tournament Statistics - ${formatedDate}`,
    showBottom: false,
    stats: [
      {
        order: 1,
        code: 'SPK',
        attr: 'value',
        label: 'HeaderAttack',
        title: 'Attack'
      },
      {
        order: 2,
        code: 'BLC',
        attr: 'value',
        label: 'BLC',
        title: 'Block'
      },
      {
        order: 3,
        code: 'SRV',
        attr: 'value',
        label: 'HeaderServe',
        title: 'Serve'
      },
      {
        order: 4,
        code: 'SCR',
        attr: 'value',
        label: 'HeaderRankByT',
        title: 'Total'
      },
      {
        order: 5,
        code: 'SCR',
        attr: 'percent',
        label: 'HeaderPercentOfTotalTeamScore',
        title: 'Percentage of total team score %',
      },
    ]
  }
  return configuration;
}

const getConfigurationSecondBox = (date) => {

  let configuration = {
    header: `Highest Reach`,
    stats: [
      {
        order: 1,
        code: 'SPIKE',
        attr: 'ee_value',
        label: 'HeaderSpikeCm',
        title: 'Spike cm',
        eventUnitEntries: true
      },
      {
        order: 2,
        code: 'BLOCK',
        attr: 'ee_value',
        label: 'HeaderBlockCm',
        title: 'Block cm',
        eventUnitEntries: true
      },
    ]
  }
  return configuration;
}

const getConfiguration = (data, breakPoint) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.captionStarters = (
    <div className="d-flex justify-content-between">
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant} />
        </strong>
      </div>
      <div>
        <Uniform data={data} />
      </div>
    </div>
  )
  configuration.columns = TableColumns();
  return configuration;
}

const Uniform = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters();
  const uniform = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'UNIFORM')?.eue_value?.toLowerCase());
  const shorts = capitalizeFirstLetter(data?.eventUnitEntries?.find(i => i?.eue_code === 'SHORTS')?.eue_value?.toLowerCase());
  return (
    <>
      <div>
        <Label data="HeaderShirt" />&nbsp;{uniform}
      </div>
    </>
  )
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEvent = useMemo(() => getConfiguration(data, breakPoint));

  const configFirstBox = useMemo(() => getConfigurationFirstBox(date));
  const configSecondBox = useMemo(() => getConfigurationSecondBox(date));

  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <>
        <StatsBox data={row?.original} config={configFirstBox} breakPoint={breakPoint} />
        <StatsBox data={row?.original} config={configSecondBox} breakPoint={breakPoint} />
      </>
    }
    />
  ), [resultStatus]);

  const players = data?.teamAthletes

  return (<>
    {data.teamAthletes && (
      <div className="start-list-side-main">
        <div className="row">
          <div className="col-12">
            <MirsTable
              id={`mirs-table-start-list-players-${mirs_rsc}-${data?.participant?.code}`}
              data={players}
              columns={configEvent.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEvent.captionStarters}
              initialSortBy={configEvent.sortBy}
            />
          </div>
        </div>
      </div>
    )
    }
  </>)
}

export default StartListSide;
